import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

/**
 * Vendor Admin is English-only today, but DSL components such as Logo use
 * react-i18next for shared accessible labels. Initialize the shared instance
 * before React renders so those components never fall back to the warning-only
 * unconfigured path.
 */
export const i18nInitPromise = i18n
  .use(initReactI18next)
  .init({
    lng: 'en',
    fallbackLng: 'en',
    supportedLngs: ['en'],
    ns: ['translation'],
    defaultNS: 'translation',
    interpolation: { escapeValue: false },
    resources: { en: { translation: {} } },
    react: { useSuspense: false },
  });

void i18nInitPromise;

export default i18n;

